import * as types from '../constants/ActionTypes'

export function toggleComponent(component, index) {
  return {
    type: types.TOGGLE_COMPONENT,
    component,
    index
  }
}

export function toggleStaticVersion(override) {
  override = (override) ? override : null;
  return {
    type: types.TOGGLE_STATIC,
    override
  }
}



// WEBPACK FOOTER //
// ./styleguide/actions/index.js